<template>
  <Fragment>
    <tr
      v-show="visible"
      @click="setCurrentDirectory({ currentDirectory: path })"
    >
      <td><span class="file-icon folder-icon"></span></td>
      <td>
        <span>
          {{ name }}
        </span>
      </td>
      <td></td>
      <td class="table-column__show"></td>
      <td class="table-column__show"></td>
      <td>{{ filesInDirectory.length }}</td>
    </tr>
    <nav-item
      v-show="!visible"
      v-for="directory in children"
      :key="directory.name"
      :parent="path"
      :children="directory.children"
      :name="directory.name"
      :path="`${path}/${directory.name}`"
    />
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import { mapMutations, mapState } from 'vuex';

export default {
  components: {
    Fragment
  },
  name: 'nav-item',
  data() {
    return {};
  },
  props: {
    parent: {
      type: String,
      required: true
    },
    children: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapMutations({
      setCurrentDirectory: 'SET_CURRENT_DIRECTORY'
    })
  },
  computed: {
    ...mapState(['currentDirectory', 'directoryFiles']),
    visible() {
      return this.currentDirectory === this.parent;
    },
    prefix() {
      return `/${this.$route.params.orgSalesforceId}/${
        this.$route.params.recordType
      }/${this.$route.params.recordTypeSalesforceId}${this.path}`;
    },
    filesInDirectory() {
      return this.directoryFiles.filter((f) => {
        return f.prefix.startsWith(this.prefix);
      });
    }
  },
  mounted() {}
};
</script>
